<template>
    <div class="banner-material-library">
        <div class="library-body">
            <!-- 左侧：模块树（对齐 galaxy） -->
            <div class="module-tree">
                <div class="module-tree-header" @click="openModuleDialog()">
                    <i class="el-icon-plus module-tree-add-icon"></i>
                    <span class="module-tree-add-text">添加模块</span>
                </div>

                <div class="module-tree-content">
                    <el-scrollbar class="module-tree-scroll">
                        <el-tree v-if="moduleData && moduleData.length" ref="moduleTreeRef" node-key="id"
                            :data="moduleData" :props="{ label: 'id', children: 'children' }" highlight-current
                            :current-node-key="moduleId" @node-click="handleModuleNodeClick">
                            <div class="module-tree-node" slot-scope="{ data }">
                                <span class="module-tree-node-label" :title="getModuleName(data)">
                                    {{ getModuleName(data) }}
                                </span>
                                <span class="module-tree-node-actions">
                                    <i class="el-icon-remove module-tree-node-del" title="删除"
                                        @click.stop="deleteModule(data)"></i>
                                    <i class="el-icon-edit module-tree-node-edit" title="编辑"
                                        @click.stop="openModuleDialog(data)"></i>
                                </span>
                            </div>
                        </el-tree>
                    </el-scrollbar>
                </div>
            </div>

            <!-- 右侧：搜索 + 表格（对齐 galaxy） -->
            <div class="main-panel">
                <div class="search-bar">
                    <el-form :inline="true" size="small" class="search-form">
                        <el-form-item label="标题">
                            <el-input v-model="searchForm.title" placeholder="请输入标题" clearable style="width: 200px;" />
                        </el-form-item>

                        <el-form-item label="状态">
                            <el-select v-model="searchForm.status" clearable placeholder="请选择" style="width: 160px;">
                                <el-option label="未上线" :value="0" />
                                <el-option label="上线" :value="1" />
                                <el-option label="下线" :value="2" />
                            </el-select>
                        </el-form-item>

                        <el-form-item label="排序">
                            <el-select v-model="searchForm.customSort" clearable placeholder="请选择"
                                style="width: 220px;">
                                <el-option label="按添加时间（近-远）" value="createdAt#desc" />
                                <el-option label="按添加时间（远-近）" value="createdAt#asc" />
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button @click="resetSearch">清空</el-button>
                            <el-button type="primary" @click="handleSearch">搜索</el-button>
                        </el-form-item>

                        <div class="search-custom-btn">
                            <el-button type="primary" @click="toUploadData()" :disabled="!moduleId">
                                新增
                            </el-button>
                        </div>
                    </el-form>
                </div>

                <div class="table-area">
                    <div class="table-wrapper">
                        <el-table ref="tableRef" :data="dataList" border size="small" style="width: 100%"
                            :height="tableHeight" v-loading="loading" row-key="id"
                            :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                            <el-table-column type="index" label="序号" width="60">
                                <template slot-scope="scope">
                                    {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" label="ID" />
                            <el-table-column label="缩略图" min-width="110" align="center">
                                <template slot-scope="scope">
                                    <div class="thumb-cell">
                                        <el-image v-if="scope.row.thumbnailUrl" class="thumb-img"
                                            :src="scope.row.thumbnailUrl"
                                            :preview-src-list="scope.row.thumbnailUrl ? [scope.row.thumbnailUrl] : []"
                                            fit="fill" :z-index="3000" />
                                        <span v-else class="thumb-placeholder">暂无图片</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="titleText" label="标题" show-overflow-tooltip />
                            <el-table-column prop="pushText" label="推送配置" show-overflow-tooltip />
                            <el-table-column prop="navText" label="跳转配置" show-overflow-tooltip />
                            <el-table-column prop="createdAtText" label="创建时间" show-overflow-tooltip />
                            <el-table-column prop="statusText" label="状态" />
                            <!-- fixed="right" -->
                            <el-table-column label="操作" width="300">
                                <template slot-scope="scope">
                                    <div class="op-row">
                                        <div class="op-drag">
                                            <svg class="drag-btn" width="20" height="20" viewBox="0 0 48 48" fill="none"
                                                xmlns="http://www.w3.org/2000/svg" @mouseenter="initSortable">
                                                <path d="M8 18H40" stroke="currentColor" stroke-width="4"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 30H40" stroke="currentColor" stroke-width="4"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 6H40" stroke="currentColor" stroke-width="4"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 42H40" stroke="currentColor" stroke-width="4"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <el-button type="primary" size="small"
                                            @click.stop="toUploadData(scope.row)">编辑</el-button>
                                        <el-button :type="scope.row.status === 1 ? 'danger' : 'success'" size="small"
                                            @click.stop="handleOffline(scope.row)">
                                            {{ scope.row.status === 1 ? "下线" : "上线" }}
                                        </el-button>
                                        <el-button type="primary" size="small"
                                            @click.stop="openTest(scope.row)">测试</el-button>
                                        <el-button type="primary" size="small"
                                            @click.stop="openOptRecord(scope.row)">操作详情</el-button>
                                        <!-- <div class="op-drag">
                                            <i class="el-icon-rank drag-btn" @mouseenter="initSortable"></i>
                                        </div> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页器 -->
                        <div class="pager">
                            <el-pagination background layout="total, prev, pager, next, jumper"
                                :current-page="params.page" :page-size="params.pageSize" :total="total"
                                @current-change="pageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 模块操作（新增/编辑） -->
        <el-dialog title="模块操作" :visible.sync="moduleDialogVisible" width="520px" :close-on-click-modal="false"
            destroy-on-close @closed="resetModuleForm">
            <el-form ref="moduleFormRef" :model="moduleForm" :rules="moduleFormRules" label-position="left"
                label-width="90px" class="module-form">
                <el-form-item required prop="name">
                    <template slot="label">
                        <span class="module-form-label">
                            <span>模块命名</span>
                        </span>
                    </template>
                    <div class="module-name-grid">
                        <div class="module-name-row" v-for="item in moduleForm.name" :key="item.locale">
                            <span class="module-name-lang">
                                {{ item.locale === 'zh_CN' ? '简体' : (item.locale === 'zh_TW' ? '繁体' : '英文') }}
                            </span>
                            <el-input v-model="item.value" placeholder="请输入" />
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="moduleDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmModuleDialog">确定</el-button>
            </div>
        </el-dialog>

        <!-- 新增/编辑 Banner -->
        <el-dialog :title="`${uploadDetailId ? '编辑' : '新增'}Banner`" :visible.sync="uploadVisible" width="800px"
            custom-class="banner-upload-dialog" :close-on-click-modal="false" :close-on-press-escape="false"
            destroy-on-close append-to-body @closed="handleUploadDialogClosed">
            <upload-data :moduleId="moduleId" :detailId="uploadDetailId" @close="handleUploadClose"
                @success="handleUploadSuccess" />
        </el-dialog>

        <!-- 操作详情 -->
        <el-dialog title="操作详情" :visible.sync="optRecordVisible" fullscreen custom-class="add-material-dialog"
            :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
            <opt-record :detailId="detailShipId" />
        </el-dialog>

        <!-- 测试 -->
        <el-dialog title="测试" :visible.sync="testVisible" width="500px" :close-on-click-modal="false"
            :close-on-press-escape="false" destroy-on-close>
            <test @confirm="testConfirm" @close="testVisible = false" />
        </el-dialog>
    </div>
</template>

<script>
import api from "@/api";
import Sortable from "sortablejs";
import { valueByLanguage } from "@/utils/college";
import { calculateDynamicOrdinal, resetDataOrdinal } from "@/utils/ordinalUtils";
import UploadData from "./components/uploadData/index.vue";
import OptRecord from "../cardMaterialLibrary/components/optRecord/index.vue";
import Test from "@/components/Test.vue";
import {
    ConditionsTypeEnum,
    ConditionsDataTypeMap
} from "@/components/PushConfig/usePushConditions";

export default {
    name: "BannerMaterialLibrary",
    components: {
        UploadData,
        OptRecord,
        Test
    },
    data() {
        return {
            loading: false,
            moduleData: [],
            moduleId: null,
            dataList: [],
            total: 0,
            params: {
                page: 1,
                pageSize: 20
            },
            searchForm: {
                title: "",
                status: null,
                customSort: null
            },
            moduleDialogVisible: false,
            moduleDetails: null,
            moduleForm: {
                name: [
                    { locale: "zh_CN", value: "" },
                    { locale: "zh_TW", value: "" },
                    { locale: "en", value: "" }
                ]
            },
            moduleFormRules: {
                name: [
                    {
                        validator(rule, value, callback) {
                            const list = Array.isArray(value) ? value : [];
                            const zhCN = list.find((x) => x && x.locale === "zh_CN");
                            const zhTW = list.find((x) => x && x.locale === "zh_TW");
                            const en = list.find((x) => x && x.locale === "en");
                            if (!zhCN || !String(zhCN.value || "").trim()) {
                                callback(new Error("请填写模块命名（简体）"));
                            } else if (!zhTW || !String(zhTW.value || "").trim()) {
                                callback(new Error("请填写模块命名（繁体）"));
                            } else if (!en || !String(en.value || "").trim()) {
                                callback(new Error("请填写模块命名（英文）"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur"
                    }
                ]
            },
            uploadVisible: false,
            uploadDetailId: null,
            optRecordVisible: false,
            testVisible: false,
            detailShipId: null,
            sortableInstance: null,
            tableHeight: 300
        };
    },
    watch: {
        moduleId() {
            this.params.page = 1;
            this.getList();
        }
    },
    mounted() {
        this.getModules();
        this.calcTableHeight();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        if (this.sortableInstance) this.sortableInstance.destroy();
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        formatDateTime(val) {
            if (!val) return "-";
            const d = new Date(val);
            if (Number.isNaN(d.getTime())) return "-";
            const pad = (n) => String(n).padStart(2, "0");
            return (
                d.getFullYear() +
                "-" +
                pad(d.getMonth() + 1) +
                "-" +
                pad(d.getDate()) +
                " " +
                pad(d.getHours()) +
                ":" +
                pad(d.getMinutes()) +
                ":" +
                pad(d.getSeconds())
            );
        },
        getModuleName(m) {
            return valueByLanguage(m && m.name, "zh_CN", true) || (m && m.id) || "-";
        },
        async getModules() {
            const res = await api.getIndexConfigModulesList({
                page: 1,
                pageSize: 2000,
                resourceType: "RESOURCE",
                type: "1"  // BANNER = "1", CARD = "2"
            });
            this.moduleData = res && res.data && res.data.items ? res.data.items : [];
            if (this.moduleData.length && !this.moduleId) {
                this.moduleId = this.moduleData[0].id;
            }
        },
        handleModuleNodeClick(node) {
            this.moduleId = node.id;
            this.getList();
        },
        resetSearch() {
            this.searchForm = { title: "", status: null, customSort: null };
            this.handleSearch();
        },
        handleSearch() {
            this.params.page = 1;
            this.getList();
        },
        async hydrateBannerThumb(items) {
            // 对齐 galaxy：valueByLanguage 返回整个对象，可能包含 url 属性
            // 如果 fileAssetId 的数据结构是 [{ locale: "zh_CN", value: id, url: "..." }, ...]
            const itemsWithUrl = items.map((row) => {
                const fileAsset = row.fileAssetId;
                if (!fileAsset || !Array.isArray(fileAsset)) {
                    return { ...row, thumbnailUrl: "" };
                }
                // 查找 zh_CN 的 fileAsset
                const zhAsset = fileAsset.find((item) => item.locale === "zh_CN");
                // 如果直接有 url，使用 url
                if (zhAsset && zhAsset.url) {
                    return { ...row, thumbnailUrl: zhAsset.url };
                }
                // 如果有 value（ID），需要通过 API 查询
                if (zhAsset && zhAsset.value) {
                    return { ...row, fileAssetIdValue: Number(zhAsset.value), thumbnailUrl: "" };
                }
                return { ...row, thumbnailUrl: "" };
            });

            // 收集需要查询的 ID
            const idsToQuery = itemsWithUrl
                .filter((item) => item.fileAssetIdValue)
                .map((item) => item.fileAssetIdValue);

            if (idsToQuery.length === 0) {
                return itemsWithUrl.map(({ fileAssetIdValue, ...rest }) => rest);
            }

            try {
                const res = await api.getFileConfigById(idsToQuery);
                const list = res && res.data && res.data.items ? res.data.items : [];
                const urlMap = {};
                list.forEach((f) => {
                    urlMap[f.id] = f.url;
                });
                return itemsWithUrl.map((item) => {
                    const { fileAssetIdValue, ...rest } = item;
                    return {
                        ...rest,
                        thumbnailUrl: fileAssetIdValue ? (urlMap[fileAssetIdValue] || "") : item.thumbnailUrl
                    };
                });
            } catch (e) {
                console.error("获取缩略图失败:", e);
                return itemsWithUrl.map(({ fileAssetIdValue, ...rest }) => rest);
            }
        },
        buildPushText(pushConditions) {
            const list = Array.isArray(pushConditions) ? pushConditions : [];
            const data = list.filter((it) => it && it.type === ConditionsTypeEnum.DATA);
            return (
                data
                    .map((it) => ConditionsDataTypeMap[it.dataType] || it.dataType)
                    .join("/") || "-"
            );
        },
        buildNavText(navigationConfig) {
            const nav = navigationConfig || {};
            // 与 NavConfig.vue 枚举保持一致：0/1/2
            const navTypeMap = {
                0: "无跳转",
                1: "应用界面",
                2: "外部链接"
            };
            // 对齐 galaxy：对常见 appPage 进行中文目标映射（其余保持原值）
            const navTargetMap = {
                SecondLevelCategory: "二级分类页面",
                MaterialDetail: "资料/素材详情页",
                MemberCenter: "会员中心"
            };
            const navType = nav.navType;
            const appPage = nav.appPage;
            if (appPage) {
                return `${navTypeMap[navType] || navType}/${navTargetMap[appPage] || appPage}`;
            }
            return navTypeMap[navType] || navType || "-";
        },
        async getList() {
            if (!this.moduleId) return;
            this.loading = true;
            const req = {
                page: this.params.page,
                pageSize: this.params.pageSize,
                ...(this.searchForm.title ? { title: this.searchForm.title } : {}),
                ...(this.searchForm.status !== null && this.searchForm.status !== undefined
                    ? { status: this.searchForm.status }
                    : {})
            };
            if (this.searchForm.customSort) {
                const arr = String(this.searchForm.customSort).split("#");
                if (arr.length === 2) {
                    req.sortBy = arr[0];
                    req.orderBy = arr[1];
                }
            }
            const res = await api.getIndexConfigModulesResourceList(this.moduleId, req);
            const items = res && res.data && res.data.items ? res.data.items : [];
            // 对齐 galaxy OnlineStatusMap：PENDING/ONLINE/OFFLINE
            const statusMap = { 0: "待上线", 1: "上线", 2: "下线" };
            const hydrated = await this.hydrateBannerThumb(items);
            this.dataList = hydrated.map((row) => {
                const titleText = valueByLanguage(row.title, "zh_CN", true) || "-";
                return {
                    ...row,
                    titleText,
                    pushText: this.buildPushText(row.pushConditions),
                    navText: this.buildNavText(row.navigationConfig),
                    createdAtText: this.formatDateTime(row.createdAt),
                    statusText: statusMap[row.status] || "-"
                };
            });
            this.total = res && res.data && res.data.count ? res.data.count : 0;
            this.loading = false;
            // 数据加载完成后重新计算表格高度并刷新布局
            this.calcTableHeight();
        },
        pageChange(val) {
            this.params.page = val;
            this.getList();
        },
        calcTableHeight() {
            this.$nextTick(() => {
                const tableWrapper = this.$el.querySelector(".table-wrapper");
                const pager = this.$el.querySelector(".pager");
                if (tableWrapper && pager) {
                    // 计算表格高度：容器高度 - 分页器高度 - 分页器 margin
                    const wrapperHeight = tableWrapper.clientHeight;
                    const pagerHeight = pager.offsetHeight || 50;
                    const pagerMargin = 12; // pager 的 margin-top
                    this.tableHeight = wrapperHeight - pagerHeight - pagerMargin;
                    // 确保最小高度
                    if (this.tableHeight < 200) {
                        this.tableHeight = 200;
                    }
                } else if (tableWrapper) {
                    // 如果没有分页器，预留空间
                    this.tableHeight = tableWrapper.clientHeight - 50;
                    if (this.tableHeight < 200) {
                        this.tableHeight = 200;
                    }
                }
                // 延迟执行 doLayout，确保 DOM 已更新
                this.$nextTick(() => {
                    if (this.$refs.tableRef) {
                        this.$refs.tableRef.doLayout();
                    }
                });
            });
        },
        handleResize() {
            this.calcTableHeight();
        },
        toUploadData(row) {
            // 对齐 galaxy：必须选中模块才能新增
            if (!this.moduleId) {
                this.$message.warning("请先选择模块");
                return;
            }
            this.uploadDetailId = row && row.id ? row.id : null;
            console.log(this.uploadDetailId);
            this.uploadVisible = true;
        },
        handleUploadClose() {
            this.uploadVisible = false;
        },
        handleUploadDialogClosed() {
            // 对齐 galaxy：关闭弹窗时清空 detailId，避免下次打开时仍显示编辑状态
            this.uploadDetailId = null;
        },
        handleUploadSuccess() {
            this.uploadVisible = false;
            this.uploadDetailId = null;
            // 对齐 galaxy：上传/编辑成功后重置分页并刷新列表
            this.params.page = 1;
            this.getList();
        },
        openOptRecord(row) {
            this.detailShipId = row && row.shipId ? row.shipId : null;
            this.optRecordVisible = true;
        },
        openTest(row) {
            this.uploadDetailId = row.id;
            this.testVisible = true;
        },
        async testConfirm(data) {
            await api.testBannerMaterial(this.uploadDetailId, data);
            this.$message.success("测试成功");
            this.testVisible = false;
        },
        async handleOffline(row) {
            // 对齐 galaxy：待上线/下线 -> 上线；上线 -> 下线
            const status = [0, 2].includes(row.status) ? 1 : 2;
            await api.updateBannerMaterialStatus(row.id, { status });
            this.$message.success(status === 1 ? "上线成功" : "下线成功");
            this.getList();
        },
        initSortable(e) {
            if (e && e.preventDefault) e.preventDefault();
            const wrapper = document.querySelector(
                ".banner-material-library .el-table__body-wrapper tbody"
            );
            if (!wrapper) return;
            if (this.sortableInstance) return;
            this.sortableInstance = Sortable.create(wrapper, {
                animation: 150,
                handle: ".drag-btn",
                onEnd: async ({ newIndex, oldIndex }) => {
                    if (newIndex === oldIndex) return;
                    const currentNode = this.dataList.splice(oldIndex, 1)[0];
                    this.dataList.splice(newIndex, 0, currentNode);

                    const newArray = [...this.dataList];
                    this.dataList = [];
                    this.$nextTick(async () => {
                        this.dataList = newArray;
                        let newOrdinal = calculateDynamicOrdinal(newIndex, this.dataList, "desc");
                        if (newOrdinal === null) {
                            const list = resetDataOrdinal({
                                dataList: this.dataList,
                                page: this.params.page,
                                pageSize: this.params.pageSize,
                                direction: "desc"
                            });
                            await Promise.all(
                                list.map((item) =>
                                    api.updateIndexConfigModulesResourceOrdinal(item.shipId, {
                                        ordinal: item.ordinal
                                    })
                                )
                            );
                            this.dataList = list;
                            return;
                        }
                        currentNode.ordinal = newOrdinal;
                        await api.updateIndexConfigModulesResourceOrdinal(currentNode.shipId, {
                            ordinal: newOrdinal
                        });
                    });
                }
            });
        },
        openModuleDialog(item) {
            if (item) {
                this.moduleDetails = item;
                this.moduleForm = {
                    name: item.name
                        ? item.name.map((it) => ({ locale: it.locale, value: it.value }))
                        : [
                            { locale: "zh_CN", value: "" },
                            { locale: "zh_TW", value: "" },
                            { locale: "en", value: "" }
                        ]
                };
            } else {
                this.moduleDetails = null;
                this.moduleForm = {
                    name: [
                        { locale: "zh_CN", value: "" },
                        { locale: "zh_TW", value: "" },
                        { locale: "en", value: "" }
                    ]
                };
            }
            this.moduleDialogVisible = true;
        },
        resetModuleForm() {
            this.moduleDetails = null;
            this.moduleForm = {
                name: [
                    { locale: "zh_CN", value: "" },
                    { locale: "zh_TW", value: "" },
                    { locale: "en", value: "" }
                ]
            };
        },
        async confirmModuleDialog() {
            // 走表单校验，确保至少简体名称必填
            this.$refs.moduleFormRef.validate(async (valid) => {
                if (!valid) return;
                // 对齐 galaxy：IndexModulesTypeEnum.BANNER = "1"（字符串）
                const payload = { name: this.moduleForm.name, resourceType: "RESOURCE", type: "1" }; // BANNER = "1"
                if (this.moduleDetails && this.moduleDetails.id) {
                    await api.updateIndexConfigModules(this.moduleDetails.id, payload);
                } else {
                    await api.addIndexConfigModules(payload);
                }
                this.$message.success("操作成功");
                this.moduleDialogVisible = false;
                await this.getModules();
            });
        },
        deleteModule(item) {
            this.$confirm("确认要删除吗?", "提示")
                .then(async () => {
                    await api.delIndexConfigModules(item.id);
                    this.$message.success("删除成功");
                    await this.getModules();
                    if (this.moduleId === item.id) {
                        this.moduleId = this.moduleData.length ? this.moduleData[0].id : null;
                    }
                })
                .catch(() => { });
        }
    }
};
</script>

<style scoped>
.banner-material-library {
    height: 100%;
    overflow: hidden;
}

.library-body {
    display: flex;
    flex: 1;
    height: 100%;
    overflow: hidden;
}

.module-tree {
    width: 250px;
    min-width: 250px;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.module-tree-header {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
}

.module-tree-add-icon,
.module-tree-add-text {
    color: #409eff;
    font-size: 14px;
    font-weight: 500;
}

.module-tree-content {
    flex: 1;
    overflow: hidden;
}

.module-tree-scroll {
    height: 100%;
    overflow: auto;
}

/* 选中节点样式 */
:deep(.el-tree-node.is-current > .el-tree-node__content) {
    background-color: #f0f0f0;
}

:deep(.el-tree-node__content) {
    padding: 0 8px;
    height: auto;
    min-height: 40px;
}

:deep(.el-tree-node__content:hover) {
    background-color: #f5f5f5;
}

.module-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    padding: 8px 0;
}

.module-tree-node-label {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
    padding-right: 8px;
}

.module-tree-node-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 8px;
    flex-shrink: 0;
}

.module-tree-node-del {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    transition: opacity 0.2s;
    flex-shrink: 0;
}

.module-tree-node-del:hover {
    opacity: 0.8;
}

.module-tree-node-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #409eff;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    transition: opacity 0.2s;
    flex-shrink: 0;
}

.module-tree-node-edit:hover {
    opacity: 0.8;
}

.main-panel {
    flex: 1;
    min-width: 0;
    padding: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.search-bar {
    flex-shrink: 0;
}

.search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
}

.search-custom-btn {
    margin-left: auto;
    display: flex;
    gap: 8px;
}

.table-area {
    margin-top: 16px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

.table-wrapper :deep(.el-table) {
    flex: 1;
    border: 1px solid #ebeef5;
}

.table-wrapper :deep(.el-table .el-table__fixed-right::before) {
    display: none;
}

.table-wrapper :deep(.el-table__body-wrapper) {
    overflow-x: auto !important;
    overflow-y: auto !important;
    max-height: none !important;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
    background: transparent;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 3px;
    transition: background-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144, 147, 153, 0.5);
}

.table-wrapper :deep(.el-table__body-wrapper) {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper) {
    scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
}

.pager {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
}

.thumb-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.thumb-img {
    height: 40px;
    max-width: 100px;
    object-fit: fill;
    display: block;
}

.thumb-placeholder {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    color: #909399;
    font-size: 12px;
    padding: 0 8px;
}

.op-row {
    display: flex;
    align-items: center;
    justify-content: center;
    /* gap: 6px; */
    flex-wrap: nowrap;
}

.op-drag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    /* margin-left: 8px; */
}

.drag-btn {
    cursor: grab;
}

.module-form-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
}

.module-name-grid {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.module-name-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.module-name-lang {
    width: 40px;
    text-align: left;
    color: #606266;
    flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    margin: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__header) {
    flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 16px;
    display: flex;
    flex-direction: column;
}

:deep(.banner-upload-dialog.el-dialog) {
    display: flex;
    flex-direction: column;
}

:deep(.banner-upload-dialog.el-dialog .el-dialog__body) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px;
}

:deep(.banner-upload-dialog.el-dialog .el-dialog__body > .banner-upload) {
    flex: 1;
    min-height: 0;
}
</style>
